import {
  Dialog,
  DialogBody,
  DialogButton,
  DialogCloseX,
  DialogContent,
  DialogHeading,
} from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"
import { usePolyglot } from "src/contexts"

const polyglotPrefix =
  "pages.data_sharing.following.manage_following.stop_following_dialog."

interface Props {
  open?: boolean;
  onOpenChange?: (o: boolean) => void;
  stopFollowing: () => Promise<void>;
  displayName: string;
}

export const StopFollowingDialog = (props: Props) => {
  const polyglot = usePolyglot()

  const {
    onOpenChange, stopFollowing, displayName,
  } = props

  const onClickStopFollowing = useCallback(
    () => {
      void stopFollowing()
    },
    [stopFollowing],
  )

  return (
    <Dialog
      open={props.open}
      onOpenChange={onOpenChange}
    >
      <DialogContent>
        <DialogHeading>
          {polyglot.t(`${polyglotPrefix}title`)}
          <DialogCloseX />
        </DialogHeading>
        <DialogBody>
          <div>
            {polyglot.t(
              `${polyglotPrefix}description_one`,
              {
                name: displayName,
              },
            )}
          </div>
          <div>
            {polyglot.t(`${polyglotPrefix}description_two`)}
          </div>
        </DialogBody>
        <DialogButton
          id="confirm-stop-following-btn"
          stylePreset="destructive"
          onClick={onClickStopFollowing}
        >
          {polyglot.t(`${polyglotPrefix}remove_cta`)}
        </DialogButton>
        <DialogButton id="Cancel">
          {polyglot.t(`${polyglotPrefix}cancel_cta`)}
        </DialogButton>
      </DialogContent>
    </Dialog>
  )
}
